<!-- OPCUA -->
@if (loadingOpcuaState | async; as state) {
  <h2 class="config-station-subtitle">{{ 'stations.form.subTitleOpcua' | translate }}</h2>
  @if (state === actionState.READY) {
    @if (successMessageOpcua) {
      <div class="alert alert-success">
        {{successMessageOpcua}}
      </div>
    }
    <ul class="config-list__ctn">
      @for (config of opcuaConfigList; track config; let i = $index) {
        <li>
          <app-configuration-station [index]="i + 1" [config]="config" [creationView]="creationView"
          [station]="station" (reloadConfigOpcuaEvent)="reloadConfigOpcua($event)"></app-configuration-station>
        </li>
      }
    </ul>
    @if (!creationView) {
      <div class="text-right mt-20">
        <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="btn btn--primary" (click)="addOpcuaConfig(bottomTarget)">
          {{'action.add_config_opcua' | translate}}
        </button>
      </div>
    }
    <div #bottomTarget></div>
    @if (creationView) {
      <div class="btn__ctn mt-30">
        <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="btn btn--outline-main-color" type="button" (click)="backToStep1()">
          {{'action.back' | translate}}
        </button>
        <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="btn btn--primary" (click)="addOpcuaConfig(bottomTarget)">
          {{'action.add_config_opcua' | translate}}
        </button>
        <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="btn btn--outline-main-color" (click)="goToCreatedStation()">
          {{'action.show_station' | translate}}
        </button>
      </div>
    }
  }
  @if (state === actionState.LOADING) {
    <span class="ui-loading" [model]="{isLoading: true}"></span>
  }
}

<!-- GIR -->
<!-- <ng-container *ngIf="loadingGirState | async as state">
<h2 class="config-station-subtitle">{{ 'stations.form.subTitleGir' | translate }}</h2>
<ng-container *ngIf="state === actionState.READY">
  <div class="alert alert-success" *ngIf="successMessageGir">
    {{successMessageGir}}
  </div>
  <ul class="config-list__ctn">
    <li *ngFor="let config of girConfigList; let i = index">
      <app-configuration-station-gir [index]="i + 1" [config]="config" [creationView]="creationView"
      [station]="station" (reloadConfigGirEvent)="reloadConfigGir($event)"></app-configuration-station-gir>
    </li>
  </ul>
  <div class="text-right mt-20" *ngIf="!creationView">
    <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="btn btn--primary" (click)="addGirConfig(bottomTarget)">
      {{'action.add_config_gir' | translate}}
    </button>
  </div>
  <div #bottomTarget></div>

  <ng-container *ngIf="creationView">
    <div class="btn__ctn mt-30">
      <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="btn btn--outline-main-color" type="button" (click)="backToStep1()">
        {{'action.back' | translate}}
      </button>
      <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="btn btn--primary" (click)="addGirConfig(bottomTarget)">
        {{'action.add_config_gir' | translate}}
      </button>
      <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="btn btn--outline-main-color" (click)="goToCreatedStation()">
        {{'action.show_station' | translate}}
      </button>
    </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="state === actionState.LOADING">
  <span class="ui-loading" [model]="{isLoading: true}"></span>
</ng-container>
</ng-container> -->